// extracted by mini-css-extract-plugin
export default {"image":"fenetre-image_image__uJKwP"};